var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",class:_vm.clazz,attrs:{"id":""}},[_c('div',{staticClass:"load-content"},[_vm._m(0),(_vm.loadingText)?_c('p',[_vm._v(_vm._s(_vm.loadingText))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-load m-0-auto"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }